import React, { useState , useEffect} from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import ProviderRequests from '../Admin/Requests/ProviderRequests';
import EventRequests from '../Admin/Requests/EventRequests';
import AmenityRequests from '../Admin/Requests/AmenityRequests';
import {Link} from 'react-router-dom';

const Container = styled.div`
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
   

  }
`;

const TabButtons = styled.div`
  display: flex;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  justify-content: center;

  button {
    background-color: #eee;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    margin: 0.25rem 0.5rem;
    border-radius: 5px;
    color: #385963;
    min-width: 120px;
    transition: background-color 0.3s ease, color 0.3s ease;

    &.active {
      background-color: #385963;
      color: white;
    }

    &:focus {
      outline: 2px solid #385963;
      outline-offset: 2px;
    }
  }

    @media (max-width: 768px) {
    flex-direction:column;
    gap: 10px;
    font-size: 14px;

  }
`;



const Header = styled.div`
    display: flex;
    justify-content: center;
    // background-color: #2D9596;
    align-items: center;
`;

const Title = styled.div`
   font-size: 30px;
   display:flex;
   flex-direction:column;
   justify-content: felx-start;
   align-items:center;
   color: #385963;
   font-weight: 600;
   margin: 100px 100px  10px ;
   gap:30px;
   height:500px;

   @media (max-width: 768px) {
    font-size: 28px; /* Smaller title for smaller screens */
     text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 20px; /* Even smaller for mobile screens */
    text-align: center; /* Center-align text */
  }
`;

const NavContainer = styled("nav")`
    display: flex;
    flex-direction:column;
    justify-content: space-between;
    padding: 30px 20px;
    background-color: transparent;
     position: relative;
     width:100%;
     align-items:center;
    // z-index: 10;

    @media (max-width: 768px) {
     padding: 20px 10px;
    }
`;

const NavTabs = styled("ul")`
  display: flex;
  list-style: none;
  align-items: center;
  gap: 20px;
  padding: 0;

  & > li {
    margin-right: 10px;

    a {
      text-decoration: none;
      color: #385963;
      font-size: 18px; /* Default font size */
      font-weight: 500;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;

      /* Add hover effect */
      &:hover {
        color: #91abb3; /* Change color on hover */
        transition: 0.4s;
      }

      /* Before pseudo-element for the underline effect */
      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 50%;
        background-color: #538392; /* Color of the underline */
        transition: all 0.4s;
      }

      /* Change width of the underline on hover */
      &:hover::before {
        width: 100%;
        left: 0;
      }
    }

    & > li:last-of-type {
      margin-right: 0;
    }

    /* Media queries for screens smaller than desktop view */
    @media (max-width: 1200px) {
      display: flex;
      align-items: center;
      a {
        font-size: 16px; /* Adjust font size */
        white-space: normal; /* Allow text to wrap */
        text-align: center; /* Center-align text */
      }
    }
    @media (max-width: 992px) {
      a {
        font-size: 14px; /* Adjust font size */
        white-space: normal; /* Allow text to wrap */
        text-align: center; /* Center-align text */
      }
    }
    @media (max-width: 768px) {
      a {
        font-size: 12px; /* Adjust font size */
        white-space: normal; /* Allow text to wrap */
        text-align: center; /* Center-align text */
      }
    }
    @media (max-width: 576px) {
      a {
        font-size: 10px; /* Adjust font size */
        white-space: normal; /* Allow text to wrap */
        text-align: center; /* Center-align text */
      }
    }
  }
`;

const ManageRequests = () => {
  const { t } = useTranslation();

    // Read from localStorage on load, default to 'providers'
  const getInitialTab = () => localStorage.getItem('activeTab') || 'providers';

  const [activeTab, setActiveTab] = useState(getInitialTab);

  // Save to localStorage whenever activeTab changes
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  return (
    <Container>
      <h2>{t('manageRequests')}</h2>
   
         <Header>
          <NavContainer>
            <NavTabs>
                <li className={activeTab === 'provider' ? 'active' : ''} onClick={() => setActiveTab('providers')}>
                  <Link height={30} width={30}>
                    {t('providerRequests')}
                  </Link>
                </li>
                <li className={activeTab === 'events' ? 'active' : ''} onClick={() => setActiveTab('events')}>
                  <Link height={30} width={30}>
                   {t('eventRequests')}
                  </Link>
                </li>
                <li className={activeTab === 'amenities' ? 'active' : ''} onClick={() => setActiveTab('amenities')}>
                  <Link height={30} width={30}>
                       {t('amenityRequests')}
                  </Link>
                </li>
             
              </NavTabs>
          </NavContainer>
            
        </Header>

      {activeTab === 'providers' && <ProviderRequests />}
      {activeTab === 'events' && <EventRequests />}
      {activeTab === 'amenities' && <AmenityRequests />}
    </Container>
  );
};

export default ManageRequests;
